import React, { Component} from "react";
import { NavLink } from "react-router-dom";


class TypeCard extends Component{
    render(){
        return(
            <NavLink to={this.props.typeLink} className='typeLink'>
              <div id="typeCard" className="d-flex flex-column justify-content-between">
                
                <img className="typeImg" src={this.props.img} alt={this.props.name}/>
                
                <center className="d-flex flex-column justify-content-center text-center cardInfos cardInfos">    
                   <p className="cardText">{this.props.name}</p>
                   <p className="priceText">{this.props.price}</p>
                </center>
              </div>
            </NavLink>
        )
    }
}
export default TypeCard;